<div class="alert" style="margin-bottom: 0px;">
  <div class="modal-header ">
    <h4 class="modal-title pull-left">{{title}}</h4>
  </div>
  <div class="modal-body"  >
    @if (form) {
      <form [formGroup]="form">
        @if (data?.reviewersList) {
          <select id='info-request-edit-form-reviewer-id'  class="form-control"
            formControlName="reviewerId" >
            <option    [ngValue]="null">Unassigned</option>
            @for (reviewer of data.reviewersList; track reviewer.id) {
              <option   [value]="reviewer.id">
                {{ reviewer.name }}
              </option>
            }
          </select>
        }
      </form>
    }
  </div>
  <div class="modal-footer justify-content-center">
    @if (hasOk()) {
      <button id="confirmation-dialog-ok-button" type="button" class="btn s_btn-confirmation-ok mr-2"   [ngClass]="getOkButtonClass()"  (click)="closeModal(ConfirmationDialogButton.Ok)">
        <div [innerHTML]="okBtnName ? okBtnName : 'OK'"></div>
        @if (hasOkSubtext()) {
          <div class="s_subtext">{{okBtnSubtext}}</div>
        }
      </button>
    }
    @if (hasCancel()) {
      <button id="confirmation-dialog-cancel-button"  [disabled]="closeDialogRequestedBy != null" type="button" class="btn s_btn-confirmation-cancel mr-2" [ngClass]="getCancelButtonClass()" (click)="closeModal(ConfirmationDialogButton.Cancel)">
        <div [innerHTML]="cancelBtnName ? cancelBtnName : 'CANCEL'"></div>
        @if (hasCancelSubtext()) {
          <div class="s_subtext">{{cancelBtnSubtext}}</div>
        }
      </button>
    }
  </div>
</div>
<ng-template #matterSubtypeTemplate let-model="item">
  <span class="subtypePicklist">{{model.name}}</span>

</ng-template>